// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { bool, func, string, object } from 'prop-types';
import { ComposedModal, ModalBody, Button, Checkbox, Loading } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import { BellRing } from 'lucide-react';

import useNumberUtils from 'Hooks/useNumberUtils';
import ModalManager from 'Containers/ModalManager/ModalManager';

const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0;
  color: #3a3a3a;

  .alert {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90px;
    height: 90px;
    background: #fff2f1;
    border-radius: 50%;
  }

  .header {
    padding: 18px 32px;
    
    p span {
      font-weight: 700;
    }
  }

  p {
      padding-right: 0 !important;
  }

  .danger {
    background: #fff2f1;
    padding: 24px 32px;
    margin-bottom: 24px;
    width: 100%;

    span {
      text-transform: capitalize;
      display: block;
      font-weight: 700;
      color: #d52b1e;
    }
  }

  button {
    min-width: 0;
    width: 100%;
    height: 50px;
    padding: 0;
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.125rem;
    border-color: inherit;
  }
`;

const StyledLoading = styled(Loading)`
  width: 1em;
  height: 1em;
  margin-left: 1em;
  left: 90px !important;
`;

const BalanceDueModal = ({
  open,
  today,
  data,
  isLoading,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const { formatNumber } = useNumberUtils();

  const [checked, setChecked] = useState(false);

  return (
    <ModalManager open={ open }>
      <ComposedModal size="sm" preventCloseOnClickOutside>
        <StyledModalBody>
          <div className="alert">
            <BellRing size={ 50 } />
          </div>
          <div className="header">
            <h2>{ t('profile.balanceDue') }</h2>
            <p dangerouslySetInnerHTML={ { __html: t('profile.balanceDueInfo', { date: today, days: data?.days }) } } />
          </div>
          <div className="danger">
            <p>{ t('profile.totalOverDueAmount') }</p>
            { data?.amounts?.map(amount => <span key={ amount?.currency_id }>{ formatNumber(amount?.amount, { currency: amount.currency_id }) }</span>) }
          </div>
          <Checkbox
            id="balanceDue"
            name="dropShipment"
            labelText={ t('profile.tookNote') }
            onChange={ (_, { checked: checkedValue }) => setChecked(checkedValue) }
            checked={ checked }
          />
          <Button
            kind="danger"
            onClick={ onConfirm }
            disabled={ !checked || isLoading }
          >
            { isLoading && <StyledLoading small withOverlay={ false } />}
            { t('profile.continue') }
          </Button>
        </StyledModalBody>
      </ComposedModal>
    </ModalManager>
  );
};

BalanceDueModal.propTypes = {
  open: bool,
  today: string,
  data: object,
  isLoading: bool,
  onConfirm: func,
};

BalanceDueModal.displayName = 'BalanceDueModalComponent';

export default BalanceDueModal;
